module.exports = __webpack_public_path__ + "img/meteostation.935f6d65.svg";